'use client';
import React, { useEffect, useState } from 'react';
import { ActionIcon, useMantineColorScheme, Tooltip, Box } from '@mantine/core';
import { IconSun, IconMoon } from '@tabler/icons-react';

export function ColorSchemeToggle() {
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';
  // Avoid hydration mismatch by rendering the icon only after client mount.
  // Server will render the outer structure but the icon will be a small placeholder.
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Tooltip label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}>
      {/* Use light variant to match other header icons. px/py handle padding. */}
      <ActionIcon
        variant="light"
        onClick={() => setColorScheme(isDark ? 'light' : 'dark')}
        aria-label="Toggle color scheme"
        px="xs"
        py="xs"
      >
        {mounted ? (
          isDark ? (
            <IconSun size={18} />
          ) : (
            <IconMoon size={18} />
          )
        ) : (
          <Box component="span" display="inline-block" w={18} h={18} />
        )}
      </ActionIcon>
    </Tooltip>
  );
}
